import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function About() {
  const [typedText, setTypedText] = useState('');
  const [roleIndex, setRoleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const roles = ['Data Analyst', 'Software Engineer', 'Frontend Developer', 'Graphic Designer'];
  const photos = ['/ajang3.jpeg', '/ajang4.jpeg', '/ajang2.jpeg', '/ajang.jpeg', '/IMG_2769.jpg'];

  useEffect(() => {
    const interval = setInterval(() => {
      setPhotoIndex(prev => (prev + 1) % photos.length);
    }, 3500);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentRole = roles[roleIndex];
    const speed = isDeleting ? 30 : 80;
    const timer = setTimeout(() => {
      if (!isDeleting) {
        if (typedText.length < currentRole.length) {
          setTypedText(currentRole.slice(0, typedText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        if (typedText.length > 0) {
          setTypedText(currentRole.slice(0, typedText.length - 1));
        } else {
          setIsDeleting(false);
          setRoleIndex((roleIndex + 1) % roles.length);
        }
      }
    }, speed);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typedText, isDeleting, roleIndex]);

  const whoCards = [
    { title: 'Who I Am', text: 'Ajang Akoi Arok is a South Sudanese Software Engineer, creative thinker, and emerging leader passionate about technology, design, and social impact. With a strong foundation in frontend development, graphic design, and data analysis, he blends logic with creativity to build solutions that are both functional and visually compelling.' },
    { title: 'Current Focus', text: "Currently pursuing a Bachelor's degree at African Leadership University, sharpening technical and leadership abilities to build scalable digital solutions. Focused on developing user-centered web applications, improving digital experiences, and leveraging data to drive informed decision-making." },
    { title: 'Track Record', text: 'Built and contributed to multiple digital projects, developed responsive web applications, designed impactful visual identities, and analyzed datasets to uncover meaningful insights. Successfully led collaborative projects and consistently delivered high-quality results under pressure.' },
    { title: 'Global Perspective', text: 'Through cross-cultural collaboration, academic experiences, and leadership exposure, developed a mindset that values diversity, innovation, and adaptability. Carries himself as a representative of South Sudanese excellence on the global stage.' },
    { title: 'Leadership Philosophy', text: 'Leadership is about service, growth, and responsibility — not just achieving results but uplifting others along the way. Values integrity, continuous improvement, and bold action. Mission is to use technology as a tool for empowerment.' },
  ];

  const storyCards = [
    { icon: 'fa-solid fa-route',         title: 'My Journey',     text: 'As a student at African Leadership University, my journey has been defined by growth, resilience, and purpose. I am building a strong foundation in software engineering while developing the leadership skills necessary to create meaningful change. Through roles in communication, social media strategy, and technical development, I have learned how to bridge ideas with action.' },
    { icon: 'fa-solid fa-bolt',          title: 'What Drives Me', text: 'I am driven by a deep commitment to using technology as a tool for transformation. I believe innovation should address real-world challenges and create opportunities where they are most needed. For me, technology is not just code — it is a pathway to empowerment.' },
    { icon: 'fa-solid fa-people-group',  title: 'My Approach',    text: 'I believe growth happens at the intersection of continuous learning and collaboration. Serving as Communication Lead at Nile Orphan Care and Social Media Manager at Youth Growth Portal strengthened my understanding of teamwork, strategy, and the power of clear communication.' },
    { icon: 'fa-solid fa-earth-africa',  title: 'Beyond Code',    text: 'Beyond academics, I actively explore emerging technologies, contribute to community-driven initiatives, and mentor aspiring developers. My long-term vision is to leverage technology to create sustainable opportunities for youth empowerment.' },
  ];

  return (
    <div className="page-wrapper">

      {/* ── HERO ── */}
      <section className="ab-hero">
        <div className="ab-hero-photo-bg">
          {photos.map((src, i) => (
            <img
              key={i}
              src={src}
              alt="Ajang Akoi Arok"
              className={`ab-hero-photo ${i === photoIndex ? 'ab-hero-photo-active' : ''}`}
            />
          ))}
        </div>
        <div className="ab-hero-box">
          <div className="ab-hero-box-accent"></div>
          <span className="ab-hero-welcome">WELCOME</span>
          <h1 className="ab-hero-name">Who is Ajang Akoi Arok?</h1>
          <p className="ab-hero-bio">A South Sudanese Software Engineer, creative thinker, and emerging leader passionate about technology, design, and social impact. Currently pursuing a Bachelor of Science in Software Engineering at African Leadership University in Kigali, Rwanda. Driven by a mission to use technology as a tool for empowerment and youth development.</p>
          <p className="ab-hero-role">
            <span style={{color:'#29abe2',fontWeight:600}}>{typedText}</span>
            <span className="typed-cursor">|</span>
          </p>
          <Link to="/about#ab-who" className="ab-hero-cta">Learn More About Me →</Link>
        </div>
        <div className="ab-hero-stripe"></div>
      </section>

      {/* ── WHO I AM ── */}
      <section id="ab-who" className="ab-section ab-section-white">
        <div className="ab-container">
          <div className="ab-who-grid">
            {/* Square photo card */}
            <div className="ab-photo-card">
              <img src="/ajang3.jpeg" alt="Ajang Akoi Arok" className="ab-photo" />
              <div className="ab-photo-caption">
                <p className="ab-photo-name">Ajang Akoi Arok</p>
                <p className="ab-photo-role">Software Engineer · Designer · Analyst</p>
              </div>
            </div>
            {/* Info */}
            <div className="ab-who-info">
              <span className="insights-label">Get To Know Me</span>
              <h2 className="ab-section-heading">Who I Am</h2>
              <div className="ab-who-items">
                {whoCards.map((c, i) => (
                  <div key={i} className="ab-who-item">
                    <h4 className="ab-who-item-title">{c.title}</h4>
                    <p className="ab-who-item-text">{c.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── MY STORY ── */}
      <section className="ab-section ab-section-gray">
        <div className="ab-container">
          <div className="ab-section-header">
            <span className="insights-label">My Journey</span>
            <h2 className="ab-section-heading">My Story</h2>
          </div>
          <div className="ab-story-grid">
            {storyCards.map((c, i) => (
              <div key={i} className="ab-story-card">
                <i className={`${c.icon} ab-story-icon`}></i>
                <h3 className="ab-story-title">{c.title}</h3>
                <p className="ab-story-text">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default About;
